import apiurl from './apiurl';
import axios from 'axios';

const updateStatus = async (idToken, params) => {

    try {
      const result = await axios.post(apiurl + 'updateStatus', null, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + idToken,
        },
        params: params,
      });
      return result;
    } catch (error) {
      throw (error);
    }
  
};

export default updateStatus;
